import type { SupervisorAuditLabelRequest } from '@avisoma/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SUPERVISOR_PRECISION_QUERY_KEY } from '../../lib/supervisorQueries';
import backend from '../../services/backend';

export type SubmitAuditLabelVars = { findingId: string; body: SupervisorAuditLabelRequest };

/** Stores the caller's label. An error shows the interceptor's toast; a success refreshes the audited precision chips. */
export function useSubmitAuditLabel() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ findingId, body }: SubmitAuditLabelVars) => (await backend.putSupervisorAuditLabel(findingId, body)).data,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: SUPERVISOR_PRECISION_QUERY_KEY }),
  });
}
